import { render, staticRenderFns } from "./ParentWorkshops.vue?vue&type=template&id=59791728&"
import script from "./ParentWorkshops.vue?vue&type=script&lang=js&"
export * from "./ParentWorkshops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports